var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(134, 67, 56)",
    width: "800px",
    height: "800px",
    viewBox: "-3.75 0 16 16",
    id: "chevron-left-16px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M33.646.146l-7.5,7.5a.5.5,0,0,0,0,.708l7.5,7.5a.5.5,0,0,0,.708-.708L27.207,8,34.354.854a.5.5,0,0,0-.708-.708Z",
    transform: "translate(-26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.2bf5eabe4e6479fc196db97e8d5af128.svg";
export { ForwardRef as ReactComponent };